import { render, staticRenderFns } from "./TabMusic.vue?vue&type=template&id=5cbeeee6&scoped=true&"
import script from "./TabMusic.vue?vue&type=script&lang=js&"
export * from "./TabMusic.vue?vue&type=script&lang=js&"
import style0 from "./TabMusic.vue?vue&type=style&index=0&id=5cbeeee6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbeeee6",
  null
  
)

export default component.exports